import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const surveyTimeAction = createAsyncThunk(
    'survey-time',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/support-server/api/survey-active-time`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const surveyTimeSlice = createSlice({
    name: 'survey-time',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(surveyTimeAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(surveyTimeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(surveyTimeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const surveyTimeReducer = surveyTimeSlice.reducer